import React from "react";
import { AcornIcon } from "./AcornIcon";
import {
  TrophyIcon,
  StarIcon,
  SparklesIcon,
  FireIcon,
  BoltIcon,
  RocketLaunchIcon,
  ShieldCheckIcon,
  AcademicCapIcon,
  HeartIcon,
  FlagIcon,
  ChartBarIcon,
} from "@heroicons/react/24/solid";

export interface IconRegistryEntry {
  key: string;
  label: string;
  component: React.FC<{ className?: string }>;
}

// Wrap AcornIcon to match the { className } signature (it also accepts size)
const AcornRegistryIcon: React.FC<{ className?: string }> = ({ className }) => (
  <AcornIcon className={className} size={24} />
);

export const ICON_REGISTRY: IconRegistryEntry[] = [
  { key: "acorn", label: "Acorn", component: AcornRegistryIcon },
  { key: "trophy", label: "Trophy", component: TrophyIcon },
  { key: "star", label: "Star", component: StarIcon },
  { key: "sparkles", label: "Sparkles", component: SparklesIcon },
  { key: "fire", label: "Fire", component: FireIcon },
  { key: "bolt", label: "Bolt", component: BoltIcon },
  { key: "rocket", label: "Rocket", component: RocketLaunchIcon },
  { key: "shield-check", label: "Shield", component: ShieldCheckIcon },
  { key: "academic-cap", label: "Academic", component: AcademicCapIcon },
  { key: "heart", label: "Heart", component: HeartIcon },
  { key: "flag", label: "Flag", component: FlagIcon },
  { key: "chart-bar", label: "Chart", component: ChartBarIcon },
];

const registryMap = new Map(ICON_REGISTRY.map((e) => [e.key, e.component]));

export function getRegistryIcon(
  key: string
): React.FC<{ className?: string }> | null {
  return registryMap.get(key) ?? null;
}
